export default __webpack_public_path__ + "static/media/paymentSuccess.f41dc842.png";